export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9015.8e01860a.jpg";